import React from 'react';
import PropTypes from 'prop-types';
import styles from './MemoryProgressBar.css';

function MemoryProgressBar({ value, max }) {
    const ratio = max > 0 ? Math.min(value / max, 1) : 0;

    return (
        <div
            className={styles.root}
            role='progressbar'
            aria-valuemin={0}
            aria-valuemax={max}
            aria-valuenow={value}
        >
            <div className={styles.fill} style={{ transform: `scaleX(${ratio})` }} />
        </div>
    );
}

MemoryProgressBar.propTypes = {
    value: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired
};

export {
    MemoryProgressBar
};
